/* UX t717 / Shopify t718 : en-tête sur une seule ligne au défilement (ordinateur). Pose .md-entete--compact sur #header-component après 320 px.
   Retour à deux rangées sous 200 px (écart voulu) : l'ancrage du défilement du navigateur compense la rangée retirée, sans aller-retour au seuil. */
(function () {
  var h = document.getElementById('header-component');
  if (!h) return;
  var mq = window.matchMedia('(min-width: 990px)');
  var compact = false;
  function maj() {
    var y = window.scrollY;
    var c = mq.matches && (compact ? y > 200 : y > 320);
    if (c === compact) return;
    compact = c;
    h.classList.toggle('md-entete--compact', c);
    if (c) h.querySelectorAll('.md-univers__deroulant[open]').forEach(function (d) { d.open = false; });
  }
  window.addEventListener('scroll', maj, { passive: true });
  mq.addEventListener('change', maj);
  maj();

  /* Shopify t720 : un seul sous-menu (Formation, Prestation) ouvert à la fois ; fermés par un clic ailleurs ou Échap. */
  var menus = h.querySelectorAll('.md-univers__deroulant');
  function fermer(sauf) { menus.forEach(function (d) { if (d !== sauf) d.open = false; }); }
  menus.forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) fermer(d); }); });
  document.addEventListener('click', function (e) { if (!e.target.closest('.md-univers__deroulant')) fermer(null); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fermer(null); });
})();
